
/**
 * Soluciones Serranas - Modo Vidriera
 *
 * true  = Solo catálogo y consulta de disponibilidad
 * false = Operatoria normal de alquileres
 */
export const CATALOG_MODE = true;
